import {useEffect, useRef, useState} from "react";

export const useInterpolatedValue = (target: number, duration: number) => {
  const maxTargetRef = useRef(target);
  const clampedTarget = Math.max(maxTargetRef.current, target);
  maxTargetRef.current = clampedTarget;

  const [value, setValue] = useState(clampedTarget);
  const animRef = useRef<number>();
  const stateRef = useRef({
    from: clampedTarget,
    startTime: performance.now(),
    current: clampedTarget,
  });

  useEffect(() => {
    stateRef.current.from = stateRef.current.current;
    stateRef.current.startTime = performance.now();
    if (animRef.current) {
      cancelAnimationFrame(animRef.current);
    }

    const tick = (now: number) => {
      const t = Math.min((now - stateRef.current.startTime) / duration, 1);
      const next =
        stateRef.current.from + (clampedTarget - stateRef.current.from) * t;
      stateRef.current.current = next;
      setValue(next);
      if (t < 1) {
        animRef.current = requestAnimationFrame(tick);
      }
    };

    animRef.current = requestAnimationFrame(tick);
    return () => {
      if (animRef.current) {
        cancelAnimationFrame(animRef.current);
      }
    };
  }, [clampedTarget, duration]);

  return value;
};
